module.exports = __webpack_public_path__ + "static/img/2.ff96842.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/2.png
// module id = rKHg
// module chunks = 0